import moment from 'moment'

import { getLastTicketSearchTimestamp } from 'tickets/redux/modules/user/selectors'
import { getHasActiveModeLoaded } from 'tickets/redux/modules/modesInfo/selectors'
import { showTicketSearchExpiryModal } from 'tickets/redux/modules/modals'

const CHECK_INTERVAL = 30 * 1000                // Check every 30 seconds
const TICKETS_SEARCH_TIMEOUT = 15 * 60 * 1000   // Expires after 15 minutes
let intervalInstance = null

export const beginTicketSearchExpiryHandler = (dispatch, getState) => {
  if (intervalInstance == null) {
    intervalInstance = setInterval(checkForTicketSearchExpiry, CHECK_INTERVAL, dispatch, getState)
  }
}

export const cancelTicketSearchExpiryHandler = () => {
  if (intervalInstance) {
    clearInterval(intervalInstance)
    intervalInstance = null
  }
}

const checkForTicketSearchExpiry = (dispatch, getState) => {
  const state = getState()

  // Skip checks if the current active mode is not yet loaded
  if (getHasActiveModeLoaded(state)) {
    const searchResponseTimestamp = getLastTicketSearchTimestamp(state)

    // If timestamp is more than 15 minutes old, notify the user that it has expired
    const searchResponseExpiry = moment(searchResponseTimestamp).add(TICKETS_SEARCH_TIMEOUT, 'ms')
    const now = moment()

    if (now.isAfter(searchResponseExpiry)) {
      dispatch(showTicketSearchExpiryModal())
      cancelTicketSearchExpiryHandler()
    }
  }
}
